import React from "react";
import withLoaderData from "../../../components/withLoaderData";
import { connect } from "react-redux";

import * as DataDelegator from "../../../components/smart/delegator/DataDelegator";
import { Editor } from "@monaco-editor/react";

class CreateEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            creationValid: true,
        }

        this.handleCreationValidation = this.handleCreationValidation.bind(this);
    }

    handleCreationValidation(markers) {
        this.setState({
            creationValid: markers.length == 0,
        })
    }

    render() {
        return (
            <div className="row mt-4">
                <div className="col-sm-12">
                    <label className="font-bold">Tuples Editor:</label>

                    {!this.state.creationValid &&
                        <div className="alert alert-danger" role="alert">
                            <div className="row">
                                <div className="col-9">
                                    Invalid JSON
                                </div>
                            </div>
                        </div>
                    }

                    <Editor
                        height="100vh"
                        defaultLanguage="json"
                        theme="vs-dark"
                        autoIndent={true}
                        onChange={this.props.onChange}
                        onValidate={this.handleCreationValidation}
                        value={this.props.value}
                        
                    />
                </div>
            </div>
        )
    }
}

export default withLoaderData(connect(DataDelegator.mapStateToProps)(CreateEditor));